import {combineReducers} from 'redux';

import admin from './admin';
import campaign from './campaign';
import cashier from './cashier';
import loading from './loading';
import location from './location';
import managers from './managers';
import member from './member';
import message from './message';
import modal from './modal';
import points from './points';
import promotion from './promotion';
import survey from './survey';
import vendor from './vendor';

const rootReducer = combineReducers({
  admin,
  campaign,
  cashier,
  loading,
  location,
  managers,
  member,
  message,
  modal,
  points,
  promotion,
  survey,
  vendor
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/